import { template as template_a3cdfcde11284ae6ba6dfb7868867182 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/meta';
const { stringify } = JSON;
export default RouteTemplate(template_a3cdfcde11284ae6ba6dfb7868867182(`
  <pre>{{stringify @model null 2}}</pre>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
